

























import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import PlanText from '@/app/features/Checkout/features/Offer/components/OfferCard/Plan/PlanText.vue';
import PaymentMethods from '@/app/features/Checkout/features/Payment/components/PaymentMethods/PaymentMethods.vue';
import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';

import { EPaymentMethod } from '@/helpers/enums';

import { IUpsell } from '@/interfaces/Upsell';
import { IInvoice, ICheckoutCartOffer } from '@/interfaces/Checkout';

import { Payment } from '@/classes/Checkout/Payment';
import { intervalBuild } from '@/helpers/checkout';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    PlanText,
    PaymentMethods,
    LoadingBlock,
  }
})
export default class UpsellPaymentModal extends Vue {
  @Prop()
  private upsell: IUpsell;

  @Prop()
  private payment: Payment;

  @CheckoutModule.Getter('selectedOffer')
  private offer!: ICheckoutCartOffer;

  @CheckoutModule.Action('buyUpsell')
  private buyUpsell: Function;

  @CheckoutModule.State('offerLoading')
  private loading!: boolean;

  private get subscription () {
    return intervalBuild(
      String(this.offer.interval_type),
      Number(this.offer.interval_count),
      false,
    ).trim();
  }

  private get invoice() {
    let invoice = {
      paymentMethod: EPaymentMethod.creditCard,
      paymentMethodInstallments: {
        number: 0,
        amount: 0,
      },
      paymentMethodAtSightAmount: 0,
      paymentMethodAtSightDiscountAmount: 0,
      paymentMethodAtSightDiscountPercentage: 0,
      originalAmount: 0,
      totalAmount: 0,
      creditAmount: 0,
      discountAmount: 0,
      discountPercentage: 0,
    };
    const paymentStructures = this.paymentStructure;
    const paymentMethod: any = this.payment.getPaymentMethod(this.selectedPaymentMethod);

    let condition = paymentStructures && paymentStructures.payment_conditions && paymentStructures.payment_conditions.find((el: any) => {
      return el.payment_method_code === this.selectedPaymentMethod;
    });

    invoice.creditAmount = paymentStructures!.credit_amount ? paymentStructures!.credit_amount : 0;

    const installments = condition && condition.installments && condition.installments.length
      ? condition.installments
      : [{number: 0, amount: 0}, {number: 0, amount: 0}];
    const firstInstallment = installments[0];
    const lastInstallment = installments[installments.length - 1];

    if (paymentStructures && firstInstallment && lastInstallment) {
      invoice.paymentMethod = this.selectedPaymentMethod;
      invoice.paymentMethodInstallments = {
        number: lastInstallment.number,
        amount: lastInstallment && lastInstallment.amount
      };

      invoice.paymentMethodAtSightAmount = parseFloat(String((firstInstallment.amount) ? firstInstallment.amount : 0));
      invoice.paymentMethodAtSightDiscountPercentage = (paymentMethod.discount_amount) ? paymentMethod.discount_amount : 0;
      invoice.originalAmount = paymentStructures.cart_initial_price;
      invoice.discountAmount = paymentStructures.global_discount_amount;
      invoice.totalAmount = paymentStructures.cart_subtotal_price;
      invoice.discountPercentage = paymentMethod.discount_percentage;
    }

    return invoice;
  }

  private get selectedPaymentMethod() {
    return this.payment && this.payment.selectedPaymentMethod;
  }

  private get paymentStructure() {
    let additionalPaymentConditions: any = [];
    let paymentStructures: any = null;

    if (this.offer && this.offer.payment_structure) {
      paymentStructures = this.generatingPaymentStructure(this.offer, this.offerPriceId);
    }

    return paymentStructures;
  }

  private get title(): string|null|undefined {
    return this.offer.related_offer_title || this.offer.subtitle;
  }

  private get offerPriceId() {
    return this.offer && this.offer.offer_price && this.offer.offer_price[0].id;
  }

  private generatingPaymentStructure(offer: ICheckoutCartOffer, offerPriceId: any): any {
    let paymentStructureArr: any = {};
    let paymentConditions: any = [];
    let additionalPaymentConditions: any = [];

    if (offer && offer.payment_structure) {
      offer.payment_structure.forEach((payment_structure_value: any) => {
        if (!payment_structure_value.is_multi_payment_options && payment_structure_value.payment_conditions.length === 1) {
          paymentConditions.push({
            offer_payment_condition_id: payment_structure_value.offer_payment_condition_id,
            ...payment_structure_value.payment_conditions[0],
          });
        }

        if (payment_structure_value.is_multi_payment_options)
          additionalPaymentConditions.push({
            offer_payment_condition_id: payment_structure_value.offer_payment_condition_id,
            ...this.generateAdditionalPaymentConditions(payment_structure_value)
          });
      });

      const paymentStructureDefault = offer.payment_structure.find((paymentStructure: any) => paymentStructure.price_id === offerPriceId);

      paymentStructureArr = {
        ...paymentStructureDefault,
        payment_conditions: paymentConditions,
        additional_payment_conditions: additionalPaymentConditions
      };
    }

    return paymentStructureArr;
  }

  private generateAdditionalPaymentConditions(payment_structure: any): any {
    let additionalPaymentCondition: any = {};
    let paymentMethodCode = payment_structure.payment_conditions.reduce((a: any, b: any) => {
      return a.payment_method_code + '_' + b.payment_method_code;
    });

    if (payment_structure) {
      additionalPaymentCondition = {
        is_multi_payment_options: payment_structure.is_multi_payment_options,
        payment_method_code: paymentMethodCode,
        payment_conditions: payment_structure.payment_conditions,
      };
    }

    return additionalPaymentCondition;
  }

  public updateUpsell(payload: any) {
    this.$emit('updateUpsell', payload);
  }
}
